<div id="center">
  <p>{{data.message}}</p>
</div>
<div id="buttonSet">
  <button mat-raised-button color="primary" (click)="confirm()">Tak</button>
  <button mat-stroked-button (click)="reject()">Nie</button>
</div>
